"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessModelHttpClient = void 0;
const atlas_engine_sdk_1 = require("@atlas-engine/atlas_engine_sdk");
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class ProcessModelHttpClient extends BaseClient_1.BaseClient {
    async getAll(identity, offset, limit) {
        const url = this.buildUrl(index_1.restSettings.paths.getAllProcessModels, offset, limit);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const result = response.result;
        return {
            processModels: result.processModels,
            totalCount: result.totalCount,
        };
    }
    async getById(processModelId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessModelById
            .replace(index_1.restSettings.params.processModelId, processModelId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processModel = response.result;
        return processModel;
    }
    async getByProcessInstanceId(processInstanceId, identity) {
        const endpoint = index_1.restSettings.paths.getProcessModelForProcessInstance
            .replace(index_1.restSettings.params.processInstanceId, processInstanceId);
        const url = this.buildUrl(endpoint);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const processModel = (0, Mappers_1.mapProcessModel)(response.result);
        return processModel;
    }
    async startProcessInstance(options, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance)
            .replace(index_1.restSettings.params.processModelId, options.processModelId);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnProcessInstanceCreated,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    async startProcessInstanceAndAwaitEndEvent(options, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnProcessInstanceFinished,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    async startProcessInstanceAndAwaitSpecificEndEvent(options, endEventId, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.startProcessInstance);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const processStartRequest = {
            ...options,
            returnOn: atlas_engine_sdk_1.DataModels.ProcessInstances.StartCallbackType.CallbackOnEndEventReached,
            endEventId: endEventId,
        };
        const response = await this.httpClient.post(url, processStartRequest, requestAuthHeaders);
        return response.result;
    }
    /**
     * @param deleteAllRelatedData Optional: If set to true, the Process Definition, as well as all related data, will be completely deleted.
     *                             Otherwise, the Process Definition will only be flagged as deleted, but all data will be kept.
     *                             Note that this won't do anything on engines with a version below v13.0.7.
     */
    async deleteDefinitionByProcessModelId(processModelId, force, identity, deleteAllRelatedData = false) {
        let endpoint = index_1.restSettings.paths.deleteProcessDefinitionByProcessModelId
            .replace(index_1.restSettings.params.processModelId, processModelId);
        let url = this.buildUrl(endpoint);
        if (force) {
            url = this.addParameterToUrl(url, 'force', force);
        }
        if (deleteAllRelatedData) {
            url = this.addParameterToUrl(url, 'delete_all_related_data', deleteAllRelatedData);
        }
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.delete(url, requestAuthHeaders);
    }
    async enableProcessModel(processModelId, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.enableProcessModel)
            .replace(index_1.restSettings.params.processModelId, processModelId);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.post(url, undefined, requestAuthHeaders);
    }
    async disableProcessModel(processModelId, identity) {
        const url = this.buildUrl(index_1.restSettings.paths.disableProcessModel)
            .replace(index_1.restSettings.params.processModelId, processModelId);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        await this.httpClient.post(url, undefined, requestAuthHeaders);
    }
}
exports.ProcessModelHttpClient = ProcessModelHttpClient;
//# sourceMappingURL=ProcessModelHttpClient.js.map